import { render } from "./FloatingFileNotesButton.vue?vue&type=template&id=36c0bbde&scoped=true"
import script from "./FloatingFileNotesButton.vue?vue&type=script&lang=js"
export * from "./FloatingFileNotesButton.vue?vue&type=script&lang=js"

import "./FloatingFileNotesButton.vue?vue&type=style&index=0&id=36c0bbde&scoped=true&lang=css"
import "./FloatingFileNotesButton.vue?vue&type=style&index=1&id=36c0bbde&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c0bbde"]])

export default __exports__